import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=aa490ee2&scoped=true&"
import script from "./Tabela.vue?vue&type=script&lang=js&"
export * from "./Tabela.vue?vue&type=script&lang=js&"
import style0 from "./Tabela.vue?vue&type=style&index=0&id=aa490ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa490ee2",
  null
  
)

export default component.exports